require('./bootstrap');

global.$ = global.jQuery = require('jquery');

require('alpinejs');
